export default __webpack_public_path__ + "static/gregF-d9660769353c5e02ee98d950315f7b3c.png";